import cloneDeep from 'lodash/cloneDeep';
import { useMemo } from 'react';

import { CommentType } from '@vimeo/comments-ui';

import { matchCommentRichText } from '../../utils/helper';

export const useFilteredComments = (
  skipFilter: boolean,
  comments?: CommentType[],
  searchQuery?: string,
) => {
  return useMemo(() => {
    if (skipFilter) {
      return { filteredComments: comments };
    }

    // create a deep copy of the comments array to avoid mutating the original array
    const decoratedComments = cloneDeep(comments);

    const lowerCaseQuery = (searchQuery && searchQuery?.toLowerCase()) || '';
    let matchCount = 0;

    const filteredComments = decoratedComments?.filter((comment: CommentType) => {
      if (comment.deletedOn && comment?.replies?.length === 0) {
        return false;
      }

      const matchedRichTextComment =
        !comment.deletedOn && matchCommentRichText(lowerCaseQuery, comment.text);

      if (matchedRichTextComment) {
        matchCount++;
      }

      const matchedReplies = comment.replies?.filter((reply: CommentType) => {
        const matchedRichTextReply = matchCommentRichText(lowerCaseQuery, reply.text);

        if (matchedRichTextReply) {
          matchCount++;
        }

        return matchedRichTextReply;
      });

      let matchedRepliesCount = matchedReplies && matchedReplies.length > 0;

      return matchedRichTextComment || matchedRepliesCount;
    });

    return { filteredComments, matchCount };
  }, [comments, searchQuery, skipFilter]);
};
